/**
 * 글자수 제한 관련 유틸리티 함수들
 */

/**
 * 글자수 placeholder 생성
 * @param {Array} flexibleData - extraSettings/textLength의 data_value
 * @param {string} fieldName - field 값 (예: "subjectComment")
 * @returns {string} - "최소 120 ~ 최대 250자" 또는 ""
 */
export function getTextLengthPlaceholder(flexibleData, fieldName) {
  if (!flexibleData || !Array.isArray(flexibleData)) return "";

  const config = flexibleData.find(
    (item) => item.field === fieldName && item.isActive === true
  );

  if (!config) return "";

  return `최소 ${config.min} ~ 최대 ${config.max}자`;
}

/**
 * 글자수 validation
 * @param {Object|Array} data - 검증할 데이터 (단일 객체 또는 배열)
 * @param {string} textKey - 텍스트가 들어있는 키 (예: "comment")
 * @param {Array} flexibleData - extraSettings/textLength의 data_value
 * @param {string} fieldName - field 값 (예: "subjectComment")
 * @param {Function} toastFn - handleToastCenterTop 함수
 * @param {string} [displayName] - 안내 메시지용 이름 (예: "과목세부특기사항")
 * @returns {boolean} - 검증 성공 여부
 */
export function validateTextLength(
  data,
  textKey,
  flexibleData,
  fieldName,
  toastFn,
  displayName = ""
) {
  if (!flexibleData || !Array.isArray(flexibleData)) return true;

  const config = flexibleData.find(
    (item) => item.field === fieldName && item.isActive === true
  );

  // 설정이 없거나 비활성화면 통과
  if (!config) return true;

  const min = parseInt(config.min);
  const max = parseInt(config.max);
  const name = displayName || config.fieldName;

  // 배열이면 각각 검증
  const dataArray = Array.isArray(data) ? data : [data];

  for (let item of dataArray) {
    const text = item[textKey] || "";

    // 빈칸은 허용
    if (text.trim() === "") continue;

    const length = text.length;

    if (length < min) {
      toastFn(
        `${name}은(는) 최소 ${min}자 이상이어야 합니다.\n(현재: ${length}자)`,
        3000,
        "#b45309"
      );
      return false;
    }

    if (length > max) {
      toastFn(
        `${name}은(는) 최대 ${max}자 이하여야 합니다.\n(현재: ${length}자)`,
        3000,
        "#b45309"
      );
      return false;
    }
  }

  return true;
}
